// Utility: render a shareable verse card to a canvas and trigger download.
export function downloadVerseCard(verse, filename = "road-to-salvation-verse.png") {
  const W = 1080;
  const H = 1350;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  // Background gradient (dark celestial)
  const bg = ctx.createLinearGradient(0, 0, 0, H);
  bg.addColorStop(0, "#05050A");
  bg.addColorStop(0.55, "#0B0D1A");
  bg.addColorStop(1, "#1B1204");
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, W, H);

  // Golden dawn radial glow at top
  const glow = ctx.createRadialGradient(W / 2, -80, 20, W / 2, -80, 900);
  glow.addColorStop(0, "rgba(234,179,8,0.55)");
  glow.addColorStop(1, "rgba(234,179,8,0)");
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, W, H);

  // Stars
  for (let i = 0; i < 220; i++) {
    const x = Math.random() * W;
    const y = Math.random() * H * 0.75;
    const r = Math.random() * 1.4 + 0.3;
    ctx.fillStyle = `rgba(248,249,250,${0.3 + Math.random() * 0.6})`;
    ctx.beginPath();
    ctx.arc(x, y, r, 0, Math.PI * 2);
    ctx.fill();
  }

  // Vignette
  const vign = ctx.createRadialGradient(W / 2, H / 2, W * 0.3, W / 2, H / 2, W * 0.75);
  vign.addColorStop(0, "rgba(0,0,0,0)");
  vign.addColorStop(1, "rgba(0,0,0,0.7)");
  ctx.fillStyle = vign;
  ctx.fillRect(0, 0, W, H);

  // Eyebrow
  ctx.fillStyle = "#EAB308";
  ctx.textAlign = "center";
  ctx.font = "500 26px 'JetBrains Mono', ui-monospace, monospace";
  const eyebrow = (verse.type === "prayer" ? "A PRAYER" : "SCRIPTURE");
  ctx.fillText(letterspace(eyebrow, 8), W / 2, 200);

  // Reference divider line
  ctx.strokeStyle = "rgba(234,179,8,0.55)";
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(W * 0.2, 260);
  ctx.lineTo(W * 0.8, 260);
  ctx.stroke();

  // Reference
  ctx.fillStyle = "#EAB308";
  ctx.font = "500 30px 'JetBrains Mono', ui-monospace, monospace";
  ctx.fillText(letterspace(verse.reference.toUpperCase(), 4), W / 2, 310);

  // Verse text (wrap)
  ctx.fillStyle = "#F8F9FA";
  const text = `\u201C${verse.text}\u201D`;
  const size = fitFontSize(ctx, text, W - 220, H * 0.5, 68, 34);
  ctx.font = `300 ${size}px 'Cormorant Garamond', 'Playfair Display', serif`;
  wrapText(ctx, text, W / 2, H / 2 - H * 0.05, W - 220, Math.round(size * 1.25));

  // Footer branding
  ctx.fillStyle = "#EAB308";
  ctx.beginPath();
  ctx.arc(W / 2 - 180, H - 130, 6, 0, Math.PI * 2);
  ctx.fill();

  ctx.fillStyle = "#F8F9FA";
  ctx.textAlign = "center";
  ctx.font = "400 34px 'Cormorant Garamond', serif";
  ctx.fillText("Road to  Salvation", W / 2 + 6, H - 120);

  ctx.fillStyle = "rgba(248,249,250,0.55)";
  ctx.font = "400 22px 'JetBrains Mono', ui-monospace, monospace";
  ctx.fillText(letterspace("DRIVE SAFE - PRAY OFTEN", 6), W / 2, H - 70);

  // Download
  canvas.toBlob((blob) => {
    if (!blob) return;
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1500);
  }, "image/png");
}

function letterspace(str, px) {
  // Naive letter-spacing via inserting hair spaces per character
  const s = String(str);
  // Use spaces to simulate tracking on canvas (which doesn't support letter-spacing)
  const gap = " ".repeat(Math.max(1, Math.round(px / 6)));
  return s.split("").join(gap);
}

function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
  const words = text.split(" ");
  const lines = [];
  let current = "";
  for (const w of words) {
    const test = current ? current + " " + w : w;
    if (ctx.measureText(test).width > maxWidth && current) {
      lines.push(current);
      current = w;
    } else {
      current = test;
    }
  }
  if (current) lines.push(current);

  const totalHeight = lines.length * lineHeight;
  let startY = y - totalHeight / 2 + lineHeight / 2;
  for (const line of lines) {
    ctx.fillText(line, x, startY);
    startY += lineHeight;
  }
}

function fitFontSize(ctx, text, maxWidth, maxTotalHeight, start, min) {
  let size = start;
  while (size >= min) {
    ctx.font = `300 ${size}px 'Cormorant Garamond', serif`;
    const lineHeight = Math.round(size * 1.25);
    const words = text.split(" ");
    let lines = 1;
    let current = "";
    for (const w of words) {
      const test = current ? current + " " + w : w;
      if (ctx.measureText(test).width > maxWidth && current) {
        lines += 1;
        current = w;
      } else {
        current = test;
      }
    }
    if (lines * lineHeight <= maxTotalHeight) return size;
    size -= 4;
  }
  return min;
}
